// Central branding / product config.
// Change the game title here and it updates everywhere (intro, menu, meta).
export const BRAND = {
    company: {
        name: "AXIS",
        tagline: "TACTICAL SYSTEMS",
        logoImage: null,
    },
    game: {
        title: "CROSSFIRE",
        subtitle: "BETA",
        credit: "DEVELOPED BY AXIS",
        titleImage: null,
    },
    version: "0.7.0-beta",
    // Admin unlock token — change per environment / rotate as needed.
    // Access News admin via `?admin=<token>` or unlock via login form.
    adminToken: "AXIS-CROSSFIRE-2026",
};

// Duration configuration for the startup sequence (ms).
// Keep numbers here so motion tuning is a single edit.
export const INTRO_TIMING = {
    BLACK_SCREEN: 1600,
    AXIS_INTRO_IN: 1400,
    AXIS_INTRO_HOLD: 2400,
    AXIS_INTRO_OUT: 900,
    BLACK_TRANSITION: 1000,
    GAME_TITLE_IN: 2600,
    GAME_TITLE_HOLD: 2600,
    GAME_TITLE_OUT: 900,
    BLACK_TRANSITION_2: 700,
    MENU_LOADING: 900,
};

// Minimum time before user can skip on FIRST watch (ms).
// Skip is available immediately on subsequent launches.
export const SKIP_GRACE_MS = 1200;

// LocalStorage flags
export const STORAGE = {
    seenIntro: "axis_seen_intro_v1",
};
